const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "8%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "11%",
    tooltip: true
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "11%",
    tooltip: true
  },
  {
    key: "inletTemperature",
    zh: "进气温度(℃)",
    en: "Inlet Temperature(℃)",
    width: "10%",
    tooltip: true
  },
  {
    key: "outputFrequency",
    zh: "频率(Hz)",
    en: "Output Frequency(Hz)",
    width: "11%",
    tooltip: true
  },
  {
    key: "ratedFrequency",
    zh: "上限频率(Hz)",
    en: "Rated Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "machineSpeed",
    zh: "主机转速(%)",
    en: "Machine Speed(%)",
    width: "10%",
    tooltip: true
  }
]

export default columns